import { Button, Form, Input, Row, Space, Typography } from 'antd'
import { LoadingOutlined } from '@ant-design/icons'
import './Login.styles.less'

import logo from '../../assets/images/Fingertip-white.svg'
import logoBackground from '../../assets/images/fingertip-bg-ellipse.svg'
import { useTranslation } from 'react-i18next'
import { FORM_TEXT, LOGIN_TEXT } from '@/config/translation/text'
// import * as crypto from 'crypto'
// import { Buffer } from 'buffer'
import { useAuth } from '@/providers/auth.provider'
import { useMutation, useQuery } from 'react-query'
// TODO HIDE THIS FEATURE WHEN IMPLEMENT MULTI SERVER REGION
// loginMicrosoftSSO
import { RequestUserServer, userLogin } from '@/services'
import { useAtom } from 'jotai'
// TODO HIDE THIS FEATURE WHEN IMPLEMENT MULTI SERVER REGION
// MSSSOErrorAtom
import { isLogin as isLoginAtom } from '@/jotai/auth.jotai'
import { useState, useEffect } from 'react'
import { VALIDATION_PATTERNS } from '@/constant/common'
// TODO HIDE THIS FEATURE WHEN IMPLEMENT MULTI SERVER REGION
// import { isEmptyValue } from '@/utils/common'

// @ts-ignore
// window.Buffer = Buffer

function IconRegion(props: { title: string }) {
  if (!props.title) {
    return <></>
  }

  return (
    <div className="region-wrap">
      <p>{props.title}</p>
    </div>
  )
}

function Login() {
  const [form] = Form.useForm()
  const { Title, Text } = Typography
  const { t } = useTranslation()
  const { loading, setUser } = useAuth()
  const [, setIsLogin] = useAtom(isLoginAtom)
  const [errorMessage, seterrorMessage] = useState('')
  const [loadingEmail, setLoadingEmail] = useState(false)

  // TODO HIDE THIS FEATURE WHEN IMPLEMENT MULTI SERVER REGION
  // const [msssoError] = useAtom(MSSSOErrorAtom)
  const watchEmail = Form.useWatch('email', form)
  const isValidEmail = VALIDATION_PATTERNS.email.test(watchEmail || '')

  // Debounce the region-discovery lookup so it fires once the user pauses typing,
  // not on every keystroke (avoids stacking many slow discovery requests).
  const [debouncedEmail, setDebouncedEmail] = useState('')
  useEffect(() => {
    const handle = setTimeout(() => {
      setDebouncedEmail(isValidEmail ? (watchEmail || '').trim() : '')
    }, 500)
    return () => clearTimeout(handle)
  }, [watchEmail, isValidEmail])

  const { data: fetchRegion } = useQuery({
    queryKey: ['region', debouncedEmail],
    enabled: !!debouncedEmail,
    queryFn: async () => {
      setLoadingEmail(true)
      try {
        const resApi: any = await RequestUserServer(debouncedEmail)
        // TODO: Next phase to implement the user can select any region
        const result = resApi?.regions?.[0]

        localStorage.setItem(
          'region',
          JSON.stringify({
            name: result?.name,
            title: result?.title,
            apiUrl: result?.api_url,
            status: result?.status,
          })
        )

        return result
      } finally {
        setLoadingEmail(false)
      }
    },
  })

  useEffect(() => {
    if (isValidEmail) {
      form.validateFields(['email'])
    }
  }, [isValidEmail, loadingEmail])

  const login = useMutation(async (values: any) => {
    const data = await userLogin(values.email.trim(), values.password)
    if (!data.error) {
      setIsLogin(true)
      setUser(data.user)
    } else {
      setIsLogin(false)
      seterrorMessage(data.message)
    }
  })

  const onFinish = async (values: any) => {
    if (!fetchRegion) {
      return
    }

    await login.mutateAsync(values)
  }

  return (
    <div className="login-container">
      <div className="login-form-container">
        <Form
          form={form}
          className="login-form"
          name="basic"
          layout="vertical"
          initialValues={{ remember: true }}
          onFinish={onFinish}
          autoComplete="off"
          disabled={login.isLoading}
        >
          <Space direction="vertical" size="middle">
            <Space direction="vertical" size="small">
              <Title level={2}>{t(LOGIN_TEXT.TITLE)}</Title>
              <Text>{t(LOGIN_TEXT.SUBTITLE)}</Text>
            </Space>

            <Form.Item
              name="email"
              rules={[
                {
                  type: 'email',
                  message: 'The input is not valid E-mail!',
                },
                {
                  required: true,
                  message: 'The field is required',
                },
                {
                  validator: () => {
                    if (!fetchRegion && isValidEmail && !loadingEmail) {
                      return Promise.reject('Email not found')
                    }

                    return Promise.resolve()
                  },
                },
              ]}
            >
              <Input
                onChange={() => {
                  seterrorMessage('')
                }}
                size="large"
                placeholder={t(FORM_TEXT.EMAIL_ADDRESS)}
                suffix={
                  loadingEmail ? (
                    <LoadingOutlined
                      style={{
                        fontSize: 24,
                        position: 'absolute',
                        right: 10,
                        top: 12,
                        color: '#ef9747',
                      }}
                    />
                  ) : (
                    <IconRegion title={fetchRegion?.title} />
                  )
                }
              />
            </Form.Item>
            <Form.Item
              name="password"
              rules={[
                {
                  required: true,
                  message: 'The field is required',
                },
              ]}
            >
              <Input.Password
                onChange={() => seterrorMessage('')}
                size="large"
                disabled={!fetchRegion}
                placeholder={t(FORM_TEXT.PASSWORD)}
              />
            </Form.Item>
            {errorMessage && (
              <p className="error-message-label">{errorMessage}</p>
            )}

            <Form.Item>
              <Button
                size="large"
                className="login-button"
                htmlType="submit"
                type="primary"
                disabled={!fetchRegion || login.isLoading}
              >
                <Row align="middle" justify="center">
                  <Title level={5}> {t(FORM_TEXT.SIGNIN)}</Title>
                </Row>
                <img src={logo} alt="button-logo" />
              </Button>
            </Form.Item>
          </Space>
        </Form>
        {/* TODO HIDE THIS FEATURE WHEN IMPLEMENT MULTI SERVER REGION */}
        {/* <Button type="text" className="sso-button" onClick={loginMicrosoftSSO}>
          or sign in with SSO{' '}
        </Button>
        {!isEmptyValue(msssoError) && (
          <div className="sso-error-container">
            <p className="sso-error">
              {msssoError ??
                'SSO Authentication Failed. Please contact your Administrator for more information.'}
            </p>
          </div>
        )} */}
      </div>

      <img className="background-logo" src={logoBackground} />
    </div>
  )
}

export default Login
